export const iconFontAwesomeWeatherCloudShowersHeavy = (
	<i className="fa-solid fa-cloud-showers-heavy"></i>
);
